// extracted by mini-css-extract-plugin
export var leftAlign = "_2m-2";
export var popper = "_2m-0";
export var subtitle = "_2m-1";